export const randomString = (e: number = 32, pre: string  = '') => {
    const t = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefahijklmnopqrstuvwxyz1234567890'
    const l = t.length
    let n = '', i=0
    for(; i < e; i++) {
        n += t.charAt(Math.floor(Math.random() * l))
    }
    return pre + n
}

export const compareBy = (propName: string) => (a: any, b: any) => {
    const v1 = a[propName]?.toUpperCase()
    const v2 = b[propName]?.toUpperCase()
    
    if(v1 > v2) {
        return 1
    } else if(v1 < v2) {
        return -1
    } else {
        return 0
    }
}

export const isObjectEmpty = (o = {}) => Object.keys(o).length === 0